import { Coins } from "lucide-react";

type CreditsBannerProps = {
  copy: {
    heading: string;
    bodyPrefix: string;
    bodySuffix: string;
    priceCaption: string;
  };
  minCredits: number;
  maxCredits: number;
  pricePerCredit: string;
};

export function CreditsBanner({ copy, minCredits, maxCredits, pricePerCredit }: CreditsBannerProps) {
  return (
    <div className="grid gap-6 rounded-[22px] border border-slate-200 bg-white px-6 py-6 shadow-[0_24px_80px_-58px_rgba(15,23,42,0.42)] ring-1 ring-slate-100 sm:px-8 lg:grid-cols-[minmax(0,1fr)_210px] lg:items-center">
      <div className="flex flex-col gap-5 sm:flex-row sm:items-center">
        <span className="flex h-20 w-20 shrink-0 items-center justify-center rounded-full border border-violet-200 bg-violet-50 text-violet-700 shadow-[0_18px_38px_-28px_rgba(109,40,217,0.75)]">
          <Coins className="h-11 w-11" strokeWidth={2.2} aria-hidden />
        </span>

        <div>
          <h3 className="text-2xl font-black leading-tight text-violet-700 sm:text-3xl">{copy.heading}</h3>
          <p className="mt-2 max-w-[690px] text-pretty text-lg font-medium leading-8 text-slate-700">
            {copy.bodyPrefix} {minCredits} to {maxCredits} {copy.bodySuffix}
          </p>
        </div>
      </div>

      <div className="rounded-2xl bg-violet-50 px-7 py-5 text-center ring-1 ring-violet-100">
        <p className="text-3xl font-black leading-none text-violet-700">{pricePerCredit}</p>
        <p className="mt-3 text-base font-medium text-slate-600">{copy.priceCaption}</p>
      </div>
    </div>
  );
}
